import React from 'react';
import { Reveal } from '../Reveal';
import { SectionBand, Eyebrow } from './SectionBand';
import { Cta } from '../Cta';
import { useScore } from '../ScoreContext';
const goodFit = ['The book is already in the world — or you are building the path before launch', 'The book supports a real business, not just a royalty stream', 'You have a method, framework, point of view, or body of work', 'The book points toward coaching, consulting, speaking, training, workshops, courses, certification, advisory, events, communities, or team implementation', 'You want the book to keep creating movement after launch'];
const notFit = ['You only want to sell more books', 'You want bestseller, PR, ads, publishing, or ghostwriting help', 'You want a cheap author website', 'You have no downstream offer', 'You want a generic funnel'];
export function FitInvestment() {
  const {
    openDiagnostic
  } = useScore();
  return <SectionBand tone="paper" width="wide" data-id="element-759" data-mp="2wb2kp413y1z3">
      <div className="max-w-3xl" data-id="element-760" data-mp="2wc5crfa62agl">
        <Reveal data-id="element-761" data-mp="125zuktmulzn5">
          <Eyebrow data-id="element-762" data-mp="126jciaci0o16">Fit &amp; investment</Eyebrow>
          <h2 className="mt-4 font-serif text-3xl leading-[1.08] text-navy md:text-5xl" data-id="element-763" data-mp="127axkr8gz3d7">
            Built for expert books with
            <br data-id="element-764" data-mp="sf55zim4qnyj" />
            <span className="italic text-seaglass" data-id="element-765" data-mp="sgq1bag9qaxg">real work behind them.</span>
          </h2>
        </Reveal>
      </div>

      <div className="mt-14 grid gap-6 md:grid-cols-2" data-id="element-766" data-mp="ni6frb5l715m">
        <Reveal delay={0.1} data-id="element-767" data-mp="1l4vo02qvu9zx">
          <div className="h-full rounded-3xl border border-seaglass/40 bg-white p-8 shadow-[0_16px_36px_-24px_rgba(139,168,159,0.7)] md:p-9" data-id="element-768" data-mp="1l311wl3vkbu9">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-seaglass" data-id="element-769" data-mp="1g3g3cbsma5i2">
              Good fit
            </p>
            <ul className="mt-6 space-y-4" data-id="element-770" data-mp="17545bopf85fl">
              {goodFit.map(item => <li key={item} className="flex items-start gap-3.5" data-id="element-771" data-mp="176x82swwy5ib">
                  <span className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-seaglass text-xs font-bold text-white" data-id="element-772" data-mp="3vxyg1lfp8uny">
                    ✓
                  </span>
                  <span className="leading-relaxed text-text" data-id="element-773" data-mp="3tcif6rvyy22c">{item}</span>
                </li>)}
            </ul>
          </div>
        </Reveal>
        <Reveal delay={0.15} data-id="element-774" data-mp="3je1hzd6fsr7u">
          <div className="h-full rounded-3xl border border-gray-200 bg-paper-dark p-8 md:p-9" data-id="element-775" data-mp="3jcrhkhc436y1">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-text-muted" data-id="element-776" data-mp="3obun02w07f6j">
              Not a fit
            </p>
            <ul className="mt-6 space-y-4" data-id="element-777" data-mp="3ak6d869892sq">
              {notFit.map(item => <li key={item} className="flex items-start gap-3.5" data-id="element-778" data-mp="3fd97yhpqqiai">
                  <span className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-gray-200 text-xs font-bold text-gray-500" data-id="element-779" data-mp="30njrlf92u7pn">
                    ✕
                  </span>
                  <span className="leading-relaxed text-text-muted" data-id="element-780" data-mp="2rmvfwr75ojfx">{item}</span>
                </li>)}
            </ul>
          </div>
        </Reveal>
      </div>

      {/* Investment */}
      <Reveal delay={0.15} data-id="element-781" data-mp="2czwp8yg4ht29">
        <div className="mt-10 overflow-hidden rounded-3xl bg-navy px-8 py-16 text-center text-paper md:px-16 md:py-20" data-id="element-782" data-mp="2cz4shkashpae">
          <div className="mx-auto max-w-2xl" data-id="element-783" data-mp="2824w613qs0wh">
            <p className="text-sm uppercase tracking-[0.22em] text-gray-400" data-id="element-784" data-mp="2m0l2hqxozpe3">
              Reader-to-Revenue Builds start at
            </p>
            <div className="mt-6 font-serif text-5xl font-semibold leading-none tracking-[-0.02em] text-sand md:text-6xl" data-id="element-785" data-mp="2h0gjnu9baikp">
              $12,500
            </div>
            <div className="mx-auto mt-10 max-w-xl space-y-4 text-lg leading-relaxed text-gray-300" data-id="element-786" data-mp="2qzpesqfwy38n">
              <p data-id="element-787" data-mp="34qugdy2ud5lm">
                Not a low-ticket funnel, a prettier author website, or a pile of
                bonus resources.
              </p>
              <p className="text-paper" data-id="element-788" data-mp="30q0sv5tb9st9">
                One done-for-you system built behind the authority the book
                already created.
              </p>
              <p data-id="element-789" data-mp="39qymcu64ihxl">
                The economics tend to make sense when one or two right-fit
                opportunities — advisory, consulting, a workshop, a cohort, a
                speaking engagement, certification, or team implementation —
                could justify it.
              </p>
            </div>
            <div className="mt-12 flex flex-col items-center gap-4" data-id="element-790" data-mp="6gip8cncxpnz">
              <Cta variant="primary" size="lg" showArrow onClick={openDiagnostic} data-id="element-791" data-mp="betyom9qpy5o">
                Get Your Reader-to-Revenue Score
              </Cta>
              <p className="max-w-md text-center text-sm leading-relaxed text-paper/55" data-id="element-792" data-mp="3av8p42rth12r">
                Already clear this is a fit?{' '}
                <a href="/audit" className="font-medium text-seaglass-light underline decoration-seaglass-light/35 underline-offset-4 transition-colors hover:text-paper hover:decoration-paper/50 focus:outline-none focus-visible:ring-2 focus-visible:ring-seaglass-light" data-id="element-793" data-mp="3judmh5rn6odc">
                  Request a Reader Path Audit
                </a>
              </p>
            </div>
          </div>
        </div>
      </Reveal>
    </SectionBand>;
}